// extracted by mini-css-extract-plugin
module.exports = {"sbCloseIcon":"_1LsdtI9","asosNameIcon":"-BhHZAH"};